module.exports = __webpack_public_path__ + "static/media/2.f22b1912.png";